import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Stats Grid Component
 * Displays PNR statistics in a responsive grid
 */
export const StatsGrid = ({ stats, loading, onFilterClick }) => {
  const statItems = [
    { label: "Total PNRs", value: stats.total_pnrs, color: "text-indigo-400", filter: null },
    { label: "Confirmed", value: stats.confirmed_seats, color: "text-emerald-400", filter: "confirmed" },
    { label: "RAC", value: stats.rac_seats, color: "text-amber-400", filter: "rac" },
    { label: "Waiting", value: stats.waiting_seats, color: "text-rose-400", filter: "waiting" },
    { label: "Cancelled", value: stats.cancelled_seats, color: "text-zinc-400", filter: "cancelled" },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 mb-8">
      {statItems.map((stat, index) => (
        <Card 
          key={index} 
          className={`stat-card bg-zinc-900/40 border-zinc-800/50 ${stat.filter ? 'cursor-pointer hover:bg-zinc-800/50 hover:border-zinc-700 transition-all' : ''}`}
          data-testid={`stat-${stat.label.toLowerCase().replace(' ', '-')}`}
          onClick={() => stat.filter && stat.value > 0 && onFilterClick(stat.filter)}
        >
          <CardContent className="p-4">
            <span className="text-sm text-zinc-500 block mb-1">{stat.label}</span>
            <span className={`text-3xl font-bold ${stat.color} block`} style={{ fontFamily: 'var(--font-heading)' }}>
              {loading ? <Skeleton className="h-9 w-12" /> : stat.value}
            </span>
            {stat.filter && stat.value > 0 && (
              <span className="text-xs text-zinc-600 mt-1 block">Click to view</span>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default StatsGrid;
